// Module
var code = "<div ng-mouseenter=\"$ctrl.close()\"> <p class=\"tooltip-header\">{{ $ctrl.tooltipHeaderText }}</p> <hr/> {{ $ctrl.tooltipSecondaryText | translate }} </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/visualizations/components/sbDeliverablePanelTooltipPanel/sb_deliverable_panel_tooltip.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;